module.exports = __webpack_public_path__ + "static/media/workshop_cart.ceb0b8e6.svg";